import { render } from "./HeroiconsSolidArrowDown.vue?vue&type=template&id=2f373bb5"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowDown.vue"]])

export default __exports__